<template>
  <div class="tx-ktgdealersearch module-map" ref="container">
    <div class="map-wrapper" ref="wrapper">
      <div :id="id" :ref="id"></div>
      <div class="map__controls">
        <div class="controls__control controls__control--reload-on-move form">
          <div class="field__wrap">
            <div class="col">
              <div class="form-group">
                <div class="checkbox" :class="{ '-checked': enableReloadOnMove }">
                  <label for="reload-on-move" class="form-check-label">
                    <input id="reload-on-move" type="checkbox" v-model="enableReloadOnMove">
                    <span>{{ $t('map.control.reloadOnMove') }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="map__popups" v-if="mobile && lastClickedIndex > -1">
        <GoogleMapPopup
            :poi="pois[lastClickedIndex]"
            @close="closeGoogleMapPopup()"/>
      </div>
    </div>
  </div>
</template>

<script>
/* global google */
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import GoogleMapPopup from '@/components/GoogleMapPopup'

export default {
  inject: ['apiBase', 'detailBase', 'mobile', 'phone'],
  data () {
    return {
      map: null,
      mapBounds: {},
      markerIconPoi: {
        url: '',
        size: new google.maps.Size(38, 53),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 53),
        scaledSize: new google.maps.Size(38, 53)
      },
      markerIconPoiActive: {
        url: '',
        size: new google.maps.Size(38, 53),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 53),
        scaledSize: new google.maps.Size(38, 53)
      },
      markerIconPoiMan: {
        url: require('@/assets/icon-map-marker-poi-man.png'),
        size: new google.maps.Size(38, 53),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 53),
        scaledSize: new google.maps.Size(38, 53)
      },
      markerIconPoiManActive: {
        url: require('@/assets/icon-map-marker-poi-man-active.png'),
        size: new google.maps.Size(38, 53),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 53),
        scaledSize: new google.maps.Size(38, 53)
      },
      markerClickPopups: [],
      lastClickedIndex: -1,
      enableReloadOnMove: true,
      skipListeners: true
    }
  },
  props: {
    id: {
      type: String,
      default: 'map'
    },
    hoveredPoiIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      brand: state => state.brand,
      pois: state => state.dealer.items,
      locationSearched: state => state.filter.location,
      latitudeSearched: state => state.filter.latitude,
      longitudeSearched: state => state.filter.longitude,
      bounds: state => state.filter.swLatitude && state.filter.swLongitude && state.filter.neLatitude && state.filter.neLongitude
    })
  },
  watch: {
    pois: function (newPois) {
      const self = this
      self.skipListeners = true

      if (self.lastClickedIndex > -1 && self.markerClickPopups.length) {
        self.markerClickPopups[self.lastClickedIndex].setMap(null)
      }
      self.markerClickPopups = []
      self.lastClickedIndex = -1

      if (self.markers && self.markers.length) {
        for (let i = 0; i < self.markers.length; i++) {
          self.markers[i].setMap(null)
        }
      }
      self.markers = []

      self.mapBounds = new google.maps.LatLngBounds()

      if (newPois.length) {
        for (let i = 0; i < newPois.length; i++) {
          self.addMapMarker(self, newPois[i], i)
        }

        if (self.locationSearched || !(self.latitudeSearched && self.longitudeSearched)) {
          self.map.fitBounds(self.mapBounds)
        }
      } else {
        self.map.setCenter({ lat: parseFloat(self.latitudeSearched), lng: parseFloat(self.longitudeSearched) })
        // self.map.setZoom(13)
      }
      self.skipListeners = false
    },
    hoveredPoiIndex: function (newHoveredPoi, oldHoveredPoi) {
      const self = this
      self.skipListeners = true
      if (oldHoveredPoi >= 0) {
        const markerIcon = self.pois[oldHoveredPoi].services.filter(service => service.id === 190).length ? self.markerIconPoiMan : self.markerIconPoi
        self.markers[oldHoveredPoi].setIcon(markerIcon)
        self.markerClickPopups[oldHoveredPoi].setMap(null)
      }
      if (newHoveredPoi >= 0) {
        const markerIcon = self.pois[newHoveredPoi].services.filter(service => service.id === 190).length ? self.markerIconPoiManActive : self.markerIconPoiActive
        self.markers[newHoveredPoi].setIcon(markerIcon)
        self.openClickPopup(self, self.pois[newHoveredPoi], newHoveredPoi)
      }
      self.skipListeners = false
    }
  },
  components: {
    GoogleMapPopup
  },
  mounted () {
    const self = this
    self.skipListeners = true

    self.markerIconPoi.url = require('@/assets/icon-map-marker-poi-' + this.brand + '.png')
    self.markerIconPoiActive.url = require('@/assets/icon-map-marker-poi-active-' + this.brand + '.png')

    const center = { lat: 51.133481, lng: 10.018343 }
    if (self.latitudeSearched && self.longitudeSearched) {
      center.lat = parseFloat(self.latitudeSearched)
      center.lng = parseFloat(self.longitudeSearched)
    }

    self.map = new google.maps.Map(self.$refs[self.id], {
      center: center,
      scrollwheel: true,
      zoom: 13,
      minZoom: 4,
      maxZoom: 18,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }]
        }
      ]
    })

    self.mapBounds = new google.maps.LatLngBounds()

    if (self.pois.length) {
      self.markers = []

      for (let i = 0; i < self.pois.length; i++) {
        self.addMapMarker(self, self.pois[i], i)
      }

      if (!self.bounds) {
        self.map.fitBounds(self.mapBounds)
      }
    }

    window.setTimeout(() => {
      self.map.addListener('center_changed', () => {
        self.getPoisByCenter()
      })
      self.map.addListener('dragstart', () => {
        self.$emit('dragstart')
      })
      self.map.addListener('dragend', () => {
        self.getPoisByCenter()
      })
    }, 1000)
    self.skipListeners = false
  },
  methods: {
    ...mapActions([
      'filter'
    ]),
    ...mapActions('filter', [
      'updateLocation',
      'resetDealername',
      'resetLocation',
      'resetBounds'
    ]),
    createPopupClass: function () {
      function Popup (position, content) {
        this.position = position

        content.classList.add('popup-bubble')

        // This zero-height div is positioned at the bottom of the bubble.
        const bubbleAnchor = document.createElement('div')
        bubbleAnchor.classList.add('popup-bubble-anchor')
        bubbleAnchor.appendChild(content)

        // This zero-height div is positioned at the bottom of the tip.
        this.containerDiv = document.createElement('div')
        this.containerDiv.classList.add('popup-container')
        this.containerDiv.appendChild(bubbleAnchor)

        // Optionally stop clicks, etc., from bubbling up to the map.
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv)
      }

      // ES5 magic to extend google.maps.OverlayView.
      Popup.prototype = Object.create(google.maps.OverlayView.prototype)

      /** Called when the popup is added to the map. */
      Popup.prototype.onAdd = function () {
        this.getPanes().floatPane.appendChild(this.containerDiv)
      }

      /** Called when the popup is removed from the map. */
      Popup.prototype.onRemove = function () {
        if (this.containerDiv.parentElement) {
          this.containerDiv.parentElement.removeChild(this.containerDiv)
        }
      }

      /** Called each frame when the popup needs to draw itself. */
      Popup.prototype.draw = function () {
        const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)

        // Hide the popup when it is far out of view.
        const display =
            Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
              ? 'block'
              : 'none'

        if (display === 'block') {
          this.containerDiv.style.left = divPosition.x + 'px'
          this.containerDiv.style.top = divPosition.y + 'px'
        }
        if (this.containerDiv.style.display !== display) {
          this.containerDiv.style.display = display
        }
        if (divPosition.y < 0) {
          this.containerDiv.classList.remove('-up')
          this.containerDiv.classList.add('-down')
        } else {
          this.containerDiv.classList.remove('-down')
          this.containerDiv.classList.add('-up')
        }
      }

      return Popup
    },
    addMapMarker: function (self, poi, index) {
      const LatLng = new google.maps.LatLng(poi.latitude, poi.longitude)
      const markerIcon = poi.services.filter(service => service.id === 190).length ? self.markerIconPoiMan : self.markerIconPoi
      self.markers[index] = new google.maps.Marker({
        position: LatLng,
        title: poi.addressLine1,
        icon: markerIcon
      })

      self.markers[index].addListener('click', function () {
        self.openClickPopup(self, poi, index)
      })

      if (!this.bounds) {
        self.mapBounds.extend(LatLng)
      }
      self.markers[index].setMap(self.map)
    },
    openClickPopup: function (self, poi, index) {
      self.skipListeners = true
      const LatLng = new google.maps.LatLng(poi.latitude, poi.longitude)

      const module = document.createElement('div')
      if (!self.mobile) {
        module.classList.add('module-map-popup')

        const wrapper = document.createElement('div')
        wrapper.classList.add('map-popup-wrapper')

        const serviceInfoHTML = poi.services.filter(service => service.id === 190).length
          ? '<div class="name__info">' +
          '<div class="info__icon icon-info-circle-before"></div>' +
          '<div class="info__overlay">' +
          '<ul class="-standard-list">' +
          `<li>${self.$t('searchResults.result.info.service.default')}</li>` +
          `<li>${self.$t('searchResults.result.info.service.man')}</li>` +
          '</ul>' +
          '<div class="overlay__shape"></div>' +
          '</div>' +
          '</div>'
          : ''

        wrapper.innerHTML = '<div class="map-popup__image">' +
            '<img src="' + (self.apiBase + 'media/' + poi.id + '/' + self.brand + '/logo.png') + '" alt="' + (poi.addressLine1 + ' Logo') + '">' +
            '</div>' +
            '<div class="map-popup__content">' +
            '<div class="content__name">' +
            '<div class="name__name">' +
            '<span>' + poi.addressLine1 + '</span>' +
            '</div>' +
            serviceInfoHTML +
            '</div>' +
            '<div class="content__links">' +
            '<div class="links__link"><a href="tel:' + poi.phone + '" class="btn -btn-beta"' + (!self.phone ? ` onclick="this.innerHTML='<span>${poi.phone}</span>';return false;"` : '') + '><span>' + self.$i18n.t('map.popup.links.phone') + '</span></a></div>' +
            '<div class="links__link"><a href="https://maps.google.de/?saddr=&daddr=' + poi.street + ', ' + poi.postcode + ' ' + poi.city + ', ' + poi.country.description + '" target="_blank" class="btn -btn-alpha"><span>' + self.$i18n.t('map.popup.links.route') + '</span></a></div>' +
            '<div class="links__link"><a href="' + self.detailBase + poi.slug + '/?brand=' + self.brand + '"><span>' + self.$i18n.t('map.popup.links.detail') + '</span></a></div>' +
            '</div>' +
            '</div>'
        module.appendChild(wrapper)
      }

      self.map.addListener('click', function () {
        if (self.lastClickedIndex >= 0) {
          self.markerClickPopups[self.lastClickedIndex].setMap(null)
        }
      })

      if (self.lastClickedIndex >= 0) {
        self.markerClickPopups[self.lastClickedIndex].setMap(null)
      }

      if (self.markerClickPopups[index]) {
        self.markerClickPopups[index].setMap(null)
      }

      if (index !== self.lastClickedIndex) {
        const Popup = self.createPopupClass()
        self.markerClickPopups[index] = new Popup(LatLng, module)

        self.markerClickPopups[index].setMap(self.map)
        self.lastClickedIndex = index
      } else {
        self.lastClickedIndex = -1
      }
      self.skipListeners = false
    },
    getPoisByCenter () {
      if (this.enableReloadOnMove && !this.skipListeners) {
        this.debouncedGetPoisByCenter()
      }
    },
    debouncedGetPoisByCenter: _.debounce(function () {
      if (this.enableReloadOnMove && !this.skipListeners) {
        this.updateLocation({ location: '', latitude: this.map.getCenter().lat(), longitude: this.map.getCenter().lng(), country: '' })
        this.resetDealername()
        this.resetBounds()
        this.filter()
      }
    }, 500),
    closeGoogleMapPopup () {
      this.markerClickPopups[this.lastClickedIndex].setMap(null)
      this.markerClickPopups = []
      this.lastClickedIndex = -1
    }
  }
}
</script>
